export default {
  names: {
    email: 'E-mail',
    password: 'Password',
    confirmPassword: 'Conferma password',
    firstName: 'Nome',
    lastName: 'Cognome',
    newEmail: 'Nuovo Indirizzo Email',
    confirmEmail: 'Conferma Nuovo Indirizzo Email',
    newPassword: 'Nuova Password'
  }
}
